import { FC } from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF } from '../constants/contact';

const HeaderContainer = styled.header`
  background-color: ${theme.white};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem 0;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Logo = styled.div`
  h1 {
    font-size: 1.8rem;
    margin: 0;
    color: ${theme.primaryDark};
    
    @media (min-width: ${theme.breakpoints.tablet}) {
      font-size: 2.2rem;
    }
  }
  
  span {
    display: block;
    font-size: 1rem;
    font-weight: 400;
    color: ${theme.textLight};
    
    @media (min-width: ${theme.breakpoints.tablet}) {
      font-size: 1.1rem;
    }
  }
`;

const ContactInfo = styled.div`
  display: none;
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    display: block;
    text-align: right;
  }
  
  p {
    margin: 0;
    font-size: 1rem;
    color: ${theme.text};
  }
  
  a {
    font-weight: 500;
  }
`;

const LocalInfo = styled.div`
  display: none;
  margin-top: 0.375rem;
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    display: block;
    text-align: right;
  }
  
  p {
    margin: 0;
    font-size: 0.9rem;
    color: ${theme.textLight};
    font-style: italic;
  }
`;

const Header: FC = () => {
  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo>
          <h1>Ruhalan Murske</h1>
          <span>Ainutlaatuista tiilenpunaista mursketta Ruovedeltä</span>
        </Logo>
        <div>
          <ContactInfo>
            <p>Ota yhteyttä:</p>
            <p><a href={CONTACT_PHONE_HREF}>{CONTACT_PHONE}</a></p>
            <p><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
          </ContactInfo>
          <LocalInfo>
            <p>Toimitus koko Pirkanmaan alueelle</p>
          </LocalInfo>
        </div>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header; 